module.exports = "data:image/gif;base64,R0lGODlhAwABAPAAAAAAAMlFJiH5BAEAAAEALAAAAAADAAEAAAICjAsAOw=="